import axios from '../providers/axios';

export const BRAZIL = 1;

export const states = (country = BRAZIL) => axios.get(`/geo/countries/${country}/states`);
export const cities = state => axios.get(`/geo/states/${state}/cities`);

export const queryCEP = cep => axios.get('/geo/address', { params: { cep } });
